// Copyright (c) Move Closer 2022.

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface IProfileTabsService {
  addTab (navTab: ProfileTabItem[]): void
  getTabs (): ProfileTab[]
}

export type ProfileTab = Omit<ProfileTabItem, 'priority'>

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface ProfileTabItem {
  label: string
  routeName: string
  priority: number
}

export const ProfileTabsServiceType = Symbol.for('IProfileTabsService')
